module.exports = __webpack_public_path__ + "img/huawei-app-gallery.0b79003d.png";